import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { portalApi, type MyMembership } from '@/api/auth';
import { auth } from '@/shared/auth/storage';
import { setApiActiveScope } from '@/shared/api/client';
import { publicRoutes } from '@/app/routes';
import { fmt, dt } from '@/shared/format';
import { SHIPMENT_STATUS_COLOR, PAYMENT_STATUS_COLOR } from '@/shared/cargo';
import { StatusBadge } from '@/shared/ui/kit';

export function PortalPage() {
  const nav = useNavigate();
  const [company, setCompany] = useState<MyMembership | null>(null);

  useEffect(() => {
    if (!auth.isAuthed) nav(publicRoutes.portalLogin, { replace: true });
    // Portal нь tenant membership шаардахгүй — scope header-ийг цэвэрлэнэ.
    setApiActiveScope(null);
  }, [nav]);

  const memQ = useQuery({ queryKey: ['portal', 'memberships'], queryFn: portalApi.memberships });
  useEffect(() => {
    if (memQ.data && memQ.data.length && !company) setCompany(memQ.data[0]);
  }, [memQ.data, company]);

  const shipQ = useQuery({
    queryKey: ['portal', 'my-shipments', company?.CompanyId],
    queryFn: () => portalApi.myShipments(company?.CompanyId),
    enabled: !!company,
  });

  function logout() {
    auth.clear();
    nav(publicRoutes.portalLogin, { replace: true });
  }

  return (
    <div style={{ maxWidth: 720, margin: '0 auto', padding: '20px 16px' }}>
      <div className="ts-flex-between" style={{ marginBottom: 18 }}>
        <div className="cg-brand" style={{ padding: 0 }}><i className="bi bi-person-circle" /> Миний илгээмж</div>
        <button className="ts-btn ts-btn-ghost" onClick={logout}><i className="bi bi-box-arrow-right" /> Гарах</button>
      </div>

      {memQ.data && memQ.data.length > 1 && (
        <select className="ts-select" style={{ marginBottom: 16 }} value={company?.CompanyId ?? ''} onChange={(e) => setCompany(memQ.data!.find((m) => m.CompanyId === e.target.value) ?? null)}>
          {memQ.data.map((m) => <option key={m.CompanyId} value={m.CompanyId}>{m.CompanyName} ({m.WarehouseCode})</option>)}
        </select>
      )}

      {company && (
        <div className="ts-card" style={{ padding: 14, marginBottom: 16 }}>
          <div className="ts-page-sub">Карго компани</div>
          <div style={{ fontWeight: 700 }}>{company.CompanyName}</div>
          <div className="ts-page-sub">Таны агуулахын код: <strong style={{ color: 'var(--ts-brand)' }}>{company.WarehouseCode}</strong></div>
        </div>
      )}

      {memQ.data && !memQ.data.length && (
        <div className="ts-card" style={{ padding: 22, textAlign: 'center' }}>
          <i className="bi bi-info-circle" style={{ fontSize: '1.6rem', color: 'var(--ts-muted)' }} />
          <p className="ts-page-sub">Таны дугаар карго компанид бүртгэлгүй байна. Карго компанидаа хандана уу.</p>
        </div>
      )}

      <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
        {(shipQ.data ?? []).map((s) => (
          <div key={s.Id} className="ts-card" style={{ padding: 14 }}>
            <div className="ts-flex-between">
              <div>
                <div style={{ fontWeight: 700 }}>{s.TrackingNo}</div>
                <div className="ts-page-sub">{s.DeclaredContent ?? ''} · {dt(s.CreatedOn)}</div>
              </div>
              <div style={{ textAlign: 'right' }}>
                <StatusBadge label={s.StatusLabel} color={SHIPMENT_STATUS_COLOR[s.Status]} />
                <div style={{ marginTop: 4 }}>
                  <StatusBadge label={`${fmt(s.Charge)} · ${s.PaymentStatusLabel}`} color={PAYMENT_STATUS_COLOR[s.PaymentStatus]} />
                </div>
              </div>
            </div>
          </div>
        ))}
        {shipQ.data && !shipQ.data.length && company && <div className="ts-page-sub" style={{ textAlign: 'center', padding: 20 }}>Илгээмж алга.</div>}
      </div>
    </div>
  );
}
